import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

// Non utilisé pour le moment mais en attente de correction pour .
@Injectable({ providedIn: 'root' })
export class PPFService {
  static canPPF: boolean = true;

  private noOrge: number = 0;

  constructor() {}

  getCanPPF(): Observable<boolean> {
    return of(PPFService.canPPF);
  }

  updateCanPPF(newPPF: boolean) {
    PPFService.canPPF = newPPF;
  }

  addNoOrge() {
    this.noOrge += 1;
    PPFService.canPPF = false;
  }

  subNoOrge() {
    this.noOrge -= 1;
    if (this.noOrge === 0) {
      PPFService.canPPF = true;
    }
  }
}
